import * as api from './stage.api-model';
import * as vm from './stage.vm';

export const mapStageFromApiToVm = (stage: api.Stage): vm.Stage => {
  return {
    id: stage.id,
    title: stage.title,
    description: stage.description,
    order: stage.order,
    routeId: stage.routeId,
  };
};

export const mapStageCollectionFromApiToVm = (stages: api.Stage[]): vm.Stage[] => {
  return stages.map(mapStageFromApiToVm);
};
